import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Button, Card, CardBody, Col, Label, Row, CardHeader, Alert } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import ProductContext from "../../../../contexts/ProductContext";
import Select from "react-select";
import { RiErrorWarningLine } from "react-icons/ri";

const Traceability = ({
    t,
    onNextButtonClicked,
    onBackButtonClicked,
    onCancelButtonClicked
}) => {
    const [originCountry, setOriginCountry] = useState();

    const {
        fetchingDetails,
        productData,
        setProductData,

        countriesList
    } = useContext(ProductContext);

    useEffect(() => {
        if(!fetchingDetails) {

            if (productData?.originCountry) {
                setOriginCountry(
                    productData.originCountry
                )
            }
            else if (productData?.importFromCountry) {
                setOriginCountry(
                    productData.importFromCountry
                )
            }
        }
    }, [ productData, fetchingDetails ]);

    const handleSubmit = (e, values) => {
        setProductData((currentState) => {
            return { ...currentState, ...values }
        });

        onNextButtonClicked();
    }

    if (!productData.name.commodity) {
        return (
            <Card>
                <CardBody>
                    <Row>
                        <Col sm='12'>
                            <Alert color="info" className="d-flex align-items-start">
                                <RiErrorWarningLine size={30} className="me-2 mt-1" />
                                <div>
                                    <strong>
                                        {t('Due Diligence & Traceability not required')}
                                    </strong>
                                    <br />
                                    {t('This step applies only to products regulated under the EU Deforestation Regulation (EUDR).')}
                                    {t('Since this product is not classified as EUDR, no due diligence or traceability data needs to be provided.')}
                                </div>
                            </Alert>
                        </Col>

                        <Col sm='12' className="d-flex justify-content-between">
                            <Button
                                color="secondary"
                                outline
                                type="button"
                                onClick={onCancelButtonClicked}
                            >
                                {t('Cancel')}
                            </Button>

                            <div>
                                <Button
                                    color="secondary"
                                    onClick={onBackButtonClicked}
                                    className="me-2"
                                    type="button"
                                >
                                    {t('Back')}
                                </Button>

                                <Button
                                    color="primary"
                                    type="button"
                                    onClick={onNextButtonClicked}
                                >
                                    {t('Next')}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    }

    return (
        <Card>
            <CardHeader className="bg-white">
                <h5 className="mb-1">
                    {t('Due Diligence & Traceability')}
                </h5>
                <p className="text-muted mb-0">
                    {t('Enter the Country of Origin and the DDS Reference and Verification numbers. This information allows the system to validate the product’s due diligence statement and ensures traceability for EUDR compliance.')}
                </p>
            </CardHeader>

            <CardBody>
                <AvForm
                    className="needs-validation m-2"
                    onValidSubmit={handleSubmit}
                >
                    <Row>
                        <Col sm='12' md="12" className="mb-3">
                            <Row>
                                <Col sm='12' md='6'>
                                    <Label htmlFor="originCountry">
                                        {t('Country of Origin')}
                                    </Label>
                                    <Select
                                        isLoading={countriesList.isFetching}
                                        isDisabled={countriesList.isFetching}
                                        id='originCountry'
                                        placeholder={
                                            t('Country') + '...'
                                        }
                                        classNamePrefix='select2-selection'
                                        options={countriesList.data}
                                        onChange={setOriginCountry}
                                        value={originCountry}
                                    />
                                    <AvField
                                        id="originCountry"
                                        name="originCountry"
                                        type="hidden"
                                        errorMessage={t("This field cannot be blank")}
                                        className="form-control"
                                        validate={{
                                            required: { value: true }
                                        }}
                                        value={originCountry}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col sm='12' md="6" className="mb-3">
                            <Label htmlFor="ddsReferenceNumber">
                                {t('DDS Reference Number')}
                            </Label>
                            <AvField
                                id="ddsReferenceNumber"
                                name="ddsReferenceNumber"
                                type="text"
                                errorMessage={t("This field cannot be blank")}
                                className="form-control"
                                validate={{
                                    required: { value: false }
                                }}
                                value={productData?.ddsReferenceNumber}
                            />
                        </Col>
                        <Col sm='12' md="6" className="mb-3">
                            <Label htmlFor="ddsVerificationNumber">
                                {t('DDS Verification Number')}
                            </Label>
                            <AvField
                                id="ddsVerificationNumber"
                                name="ddsVerificationNumber"
                                type="text"
                                errorMessage={t("This field cannot be blank")}
                                className="form-control"
                                validate={{
                                    required: { value: false }
                                }}
                                value={productData?.ddsVerificationNumber}
                            />
                        </Col>

                        <Col sm='12' className="d-flex justify-content-between">
                            <Button
                                color="secondary"
                                outline
                                type="button"
                                onClick={onCancelButtonClicked}
                            >
                                {t('Cancel')}
                            </Button>

                            <div>
                                <Button
                                    color="secondary"
                                    onClick={onBackButtonClicked}
                                    className="me-2"
                                    type="button"
                                >
                                    {t('Back')}
                                </Button>

                                <Button
                                    color="primary"
                                    type="submit"
                                >
                                    {t('Next')}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </AvForm>
            </CardBody>
        </Card>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user: state.Login.user,
        token: token
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(Traceability))
)